import { type FilterValue } from "antd/lib/table/interface";

export const findFilterInSearch = (
  mnemonic: string,
  filters: string[],
  currentSearch: string | null,
): string[] | null => {
  if (currentSearch == null) {
    return null;
  }
  const newFilters: string[] = [];

  const regex = new RegExp(`${mnemonic}:([a-z]+)`, "gi");
  const matches = [...currentSearch.matchAll(regex)];

  for (const filter of filters) {
    const hasMatch = matches.some((match) => {
      const searchValue = match[1].toLowerCase();
      return filter.toLowerCase().includes(searchValue);
    });
    if (hasMatch) {
      newFilters.push(filter);
    }
  }

  return newFilters.length === 0 ? null : newFilters;
};

const filtersMap = {
  domain: "domain",
  title: "title",
  issueStatus: "status",
  sourceType: "source_type",
  online: "status",
  instanceType: "type",
};

const mnemonics = Object.values(filtersMap).join("|");
const andOrStart = /^\s*(and|or)\s+/i;
const andOrEnd = /\s+(and|or)\s*$/i;
const mnemonicPattern = new RegExp(
  `(${mnemonics}):.+?(\\s+(and|or)\\s+(?=[a-z_]+:)|$)`,
  "gi",
);

export const addfiltersToSearchString = (
  filters: Record<string, FilterValue | null>,
  currentSearch: string,
): string => {
  const newSearch: string[] = [];
  Object.entries(filters).forEach(([key, value]) => {
    if (value != null) {
      const filterKey = filtersMap[key as keyof typeof filtersMap];
      newSearch.push(
        Object.values(value)
          .map((val) => `${filterKey}:${val.toString()}`)
          .join(" or "),
      );
    }
  });
  return newSearch
    .join(" and ")
    .concat(" and ", currentSearch.replaceAll(mnemonicPattern, ""))
    .replace(andOrStart, "")
    .replace(andOrEnd, "");
};
